// Capa de acceso a datos del módulo Dominios (4.2: "Gestión de subdominios
// y dominios personalizados"). Alcance de esta fase, según 15.1 (MVP):
// SOLO subdominio — dominio personalizado es funcionalidad de plan y
// aparece recién en la Versión 1.0 del roadmap (15.2, verificación DNS
// automatizada). El subdominio principal de cada empresa ya se crea solo,
// como parte de `crear_empresa` (fn_crear_empresa) — este módulo es para
// SUPERVISAR ese estado y corregirlo manualmente si hace falta (ej. marcar
// `estado_dns = verificado` una vez confirmado en Cloudflare), no para
// darlos de alta uno por uno a mano.

import { supabaseClient } from '@plataforma/supabase-client';

export async function listarDominios() {
  return supabaseClient()
    .from('dominio')
    .select('id, empresa_id, tipo, valor, estado_dns, es_principal, creado_en, empresa (nombre)')
    .order('creado_en', { ascending: false });
}

/**
 * @param {string} dominioId
 * @param {{ estado_dns?: 'pendiente' | 'verificado' | 'error', valor?: string }} cambios
 */
export async function actualizarDominio(dominioId, cambios) {
  return supabaseClient().from('dominio').update(cambios).eq('id', dominioId).select().single();
}
